<template>
  <div>
    <div>
      <h2 class="mb-5">
        Where would you like to work?
      </h2>
    </div>
    <div v-if="isFetchingData || isFetchingUserLocationGroupings">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <div v-else>
      <div
        v-for="(categoryItems, category) in formattedLocations"
        :key="category"
      >
        <p class="font-weight-bold">{{ category | capitalize }}</p>
        <Checkbox
          @change="val => (locations = val)"
          :selected-values="initialLocations"
          :options="categoryItems"
          isLarge
          mixed
        />
      </div>
    </div>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { createNamespacedHelpers } from "vuex";
import { USERS_NAMESPACE } from "@/store/modules/users";
import {
  ADD_USER_JOB_PREFERENCE,
  FETCH_USER_LOCATION_GROUPINGS
} from "@/store/modules/users/actions";
import {
  GET_LOCATION_GROUPINGS,
  GET_IS_FETCHING_DATA
} from "@/store/modules/data/getters";
import {
  GET_USER_LOCATION_GROUPINGS,
  GET_IS_FETCHING_USER_LOCATION_GROUPINGS
} from "@/store/modules/users/getters";
import Checkbox from "@/components/common/Checkbox";
import { map } from "lodash";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapGetters: mapDataGetters } = createNamespacedHelpers(DATA_NAMESPACE);
const {
  mapGetters: mapUserGetters,
  mapActions: mapUserActions
} = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  name: "Location",
  components: {
    PrimaryButton,
    Checkbox
  },
  props: {
    userId: String
  },
  async created() {
    await this.fetchUserLocationGroupings(this.userData.id);
    this.locations = [...this.initialLocations];
  },
  data() {
    return {
      locations: [],
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapDataGetters({
      locationsGroupings: GET_LOCATION_GROUPINGS,
      isFetchingData: GET_IS_FETCHING_DATA
    }),
    ...mapUserGetters({
      userLocationGroupings: GET_USER_LOCATION_GROUPINGS,
      isFetchingUserLocationGroupings: GET_IS_FETCHING_USER_LOCATION_GROUPINGS
    }),
    initialLocations() {
      return map(this.userLocationGroupings, "id");
    },
    formattedLocations() {
      return this.locationsGroupings.reduce(
        (formattedLocations, { category, name, id }) => {
          const functionItem = {
            label: name,
            value: id
          };
          if (formattedLocations[category]) {
            formattedLocations[category].push(functionItem);
          } else {
            formattedLocations[category] = [functionItem];
          }
          return formattedLocations;
        },
        {}
      );
    }
  },
  methods: {
    ...mapUserActions({
      addUserJobPreference: ADD_USER_JOB_PREFERENCE,
      fetchUserLocationGroupings: FETCH_USER_LOCATION_GROUPINGS
    }),
    async handleUpload() {
      this.isLoading = true;
      await this.addLocations();
      this.isLoading = false;
    },
    async nextStep() {
      this.$emit("nextStep");
    },
    async addLocations() {
      await this.addUserJobPreference({
        userId: this.userId,
        data: {
          jobPreferenceIds: this.locations,
          jobPreferenceType: "location_grouping"
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
